import React from 'react'
import { useTranslation } from 'react-i18next'

import c from './FeatureDisabled.module.scss'

function FeatureDisabled() {
  const { t } = useTranslation()

  return (
    <div className={c.notification}>
      <p className={c.notificationText}>{t('functionalityNotAvailable')}</p>
    </div>
  )
}

export default FeatureDisabled
